import {
  ASSET_TYPE,
  PERMISSION_TYPE,
  UserPermissions,
} from "../domain/device/entities/auth";
import { useAuthStore } from "../store";

/**
 * Get asset permissions for a specific venue
 */
export const getAssetPermissionsForVenue = (
  permissions: UserPermissions | undefined,
  venueId: number,
  assetType: ASSET_TYPE
): PERMISSION_TYPE[] => {
  if (!permissions) return [];

  const venue = permissions.find((v) => +v.venueId === +venueId);
  if (!venue) return [];

  const asset = venue.assets[assetType];
  return asset || [];
};

/**
 * Check if user has a specific permission for a venue
 */
export const hasPermissionForVenue = (
  permissions: UserPermissions | undefined,
  venueId: number,
  assetType: ASSET_TYPE,
  permissionType: PERMISSION_TYPE
): boolean => {
  const isAdmmin = useAuthStore.getState().user?.is_admin;
  if (isAdmmin) return true;
  const assetPermissions = getAssetPermissionsForVenue(
    permissions,
    venueId,
    assetType
  );
  return assetPermissions.includes(permissionType);
};

// /**
//  * Get all permissions for a specific venue (legacy compatibility)
//  */
// export const getLegacyAssetPermissions = (
//   permissions: UserPermissions | undefined,
//   assetType: ASSET_TYPE
// ): PERMISSION_TYPE[] => {
//   if (!permissions || permissions.length === 0) return [];

//   // For backward compatibility, if only one venue exists, use its permissions
//   if (permissions.length === 1) {
//     const asset = permissions[0].assets.find((a) => a.name === assetType);
//     return asset?.permissions || [];
//   }

//   // If multiple venues exist, return empty array to force explicit venue specification
//   return [];
// };
